import { Box } from "@mui/material"
import ComboBox from "components/ComboBox"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { useCallback, useContext, useState } from "react"
import { modifyPOICombo } from "branch/functions/modifyPOICombo"
import { jobOrderColNm } from "constants/jobOrderConstant"
import POIDialog from "pages/Menu2/POIManagement/POIDialog"


let currentPOICombo = "TakePOIId"
const colNmMode = {
  TakePOIId: "TAKE",
  LocPOIId: "LOC",
  RtnPOIId: "RTN"
}
const POIComboWithAdd = ({ dialogData, setDialogData, sx, name }) => {

  const { msData, setMSData, loadMSData, ax } = useContext(GlobalStateContext)
  const [dialogPOIOpen, setDialogPOIOpen] = useState(false)

  const handleSelecPOIId = useCallback((name) => (id) => {
    currentPOICombo = name
    if (id === -1) {
      setDialogPOIOpen(true)
      setDialogData(oldState => ({ ...oldState, [name]: null }))
    } else {
      setDialogData(oldState => ({ ...oldState, [name]: id }))
    }
  }, [setDialogData])

  const onPOIFinish = useCallback(async (id) => {
    await loadMSData(ax, setMSData, null)
    setDialogData(o => ({ ...o, [currentPOICombo]: id }))
  }, [ax, setMSData, setDialogData, loadMSData])

  return (
    <Box>
      <ComboBox sx={sx}
        options={modifyPOICombo(msData.poiComboWithAdd, colNmMode[name], dialogData.ShpmTypId)}
        label={jobOrderColNm[name]}
        selectedId={dialogData[name]}
        setSelectedId={handleSelecPOIId(name)} />
      <POIDialog selectedId={0} dialogOpen={dialogPOIOpen} setDialogOpen={setDialogPOIOpen}
        onFinish={onPOIFinish} lastFilter={null} />
    </Box>
  )
}

export default POIComboWithAdd